export const ME = '__hs__ME';
export const ALL_DEACTIVATED_OWNERS = '__hs__DEACTIVATED_OWNERS';
export const MY_TEAM = '__hs__MY_TEAM';
export const MY_USER_ID = '__hs__ID';